import SubCategoryScreen from './SubCategoryScreen';

export default SubCategoryScreen;
